export default function HTMLElementShim () {
  return Reflect.construct(HTMLElement, [], Object.getPrototypeOf(this).constructor)
}

Object.setPrototypeOf(HTMLElementShim.prototype, HTMLElement.prototype)
Object.setPrototypeOf(HTMLElementShim, HTMLElement)
